import { render, staticRenderFns } from "./addUserFromSearch.vue?vue&type=template&id=2457ee11&"
import script from "./addUserFromSearch.js?vue&type=script&lang=js&"
export * from "./addUserFromSearch.js?vue&type=script&lang=js&"
import style0 from "./addUserFromSearch.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports